import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowUpRight } from "lucide-react";
import api from "@/lib/api";
import Reveal from "@/components/marketing/Reveal";
import { Skeleton } from "@/components/ui/skeleton";

export default function Blog() {
  const { data: posts, isLoading } = useQuery({
    queryKey: ["blog"],
    queryFn: async () => (await api.get("/blog")).data,
  });

  return (
    <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-24">
      <Reveal>
        <div className="max-w-2xl">
          <div className="text-xs font-medium uppercase tracking-wider text-pulse-green">The Pulse Journal</div>
          <h1 className="mt-3 text-5xl font-bold tracking-tight text-pulse-navy md:text-6xl">Ideas for calmer venues.</h1>
          <p className="mt-5 text-lg text-slate">Practical guides on bookings, revenue and running a venue business without the chaos.</p>
        </div>
      </Reveal>

      <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {isLoading &&
          Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="overflow-hidden rounded-xl border border-slate-200">
              <Skeleton className="h-48 w-full" />
              <div className="space-y-3 p-6"><Skeleton className="h-4 w-24" /><Skeleton className="h-6 w-full" /><Skeleton className="h-4 w-full" /></div>
            </div>
          ))}
        {posts?.map((p, i) => (
          <Reveal key={p.slug} delay={i * 0.08}>
            <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}
              className="group block h-full overflow-hidden rounded-xl border border-slate-200 bg-white transition-all duration-200 hover:-translate-y-1 hover:shadow-pulse-md">
              <div className="relative h-48 overflow-hidden">
                <img src={p.cover} alt={p.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="p-6">
                <div className="text-xs font-medium uppercase tracking-wider text-slate">{p.read_time}</div>
                <h3 className="mt-2 text-xl font-semibold leading-snug text-pulse-navy">{p.title}</h3>
                <p className="mt-2 line-clamp-2 text-sm text-slate">{p.excerpt}</p>
                <div className="mt-4 flex items-center gap-1 text-sm font-semibold text-pulse-green">
                  Read article <ArrowUpRight size={15} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </div>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
